<template>
  <div class="form-group form-group-spacer position-relative">
    <SInput
      v-bind="filteredAttrs"
      ref="search"
      v-model="localModelValue"
      left-icon="icon-search-o-24"
      :label-text="inputLabelSrOnlyText || $t('global.search')"
      hide-label
      name="search"
      class="py-2"
      :placeholder-is-single-line="true"
      data-cy="sdui-search-input"
      autocomplete="off"
      type="search"
      @update:model-value="handleUpdate"
    />
    <div v-if="loading" class="input-controls d-flex position-absolute h-100">
      <sdui-loader class="p-3" />
    </div>
  </div>
</template>

<script>
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiSearch',
  components: { SduiLoader },
  props: {
    modelValue: {
      type: String,
      default: '',
    },

    loading: {
      // make sure it's always true/false
      type: Boolean,
      default: false,
    },

    inputLabelSrOnlyText: {
      type: String,
      default: '',
    },

    debounce: {
      type: Number,
      default: undefined,
    },
  },

  data: () => ({
    searchTimeout: undefined,
  }),

  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },

      set(value) {
        this.$emit('update:modelValue', value)
      },
    },

    filteredAttrs() {
      const { class: _cls, style: _style, ...otherAttrs } = this.$attrs
      return otherAttrs
    },
  },

  emits: ['update:modelValue', 'update'],

  methods: {
    async handleUpdate(val) {
      if (this.debounce && this.debounce > 0) {
        clearTimeout(this.searchTimeout)

        this.searchTimeout = setTimeout(async () => {
          this.doUpdate(val)
        }, this.debounce)
        return
      }

      this.doUpdate(val)
    },

    doUpdate(val) {
      this.localModelValue = val
      this.$emit('update:modelValue', val)
      this.$emit('update', val)
    },

  },

  watch: {},
  created() {},
}
</script>

<style scoped lang="scss">
.form-group.position-relative {
  .input-controls {
    width: auto;
    top: 0;
    right: 10px;
  }

  .custom-spinner {
    &::before {
      border-top-color: $color-secondary;
    }
  }

  :deep(div) {
    position: relative;
  }
}

// custom search icon
.sdui-icon {
  left: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  pointer-events: none;
}

:deep(input[type='search']::-webkit-search-decoration),
:deep(input[type='search']::-webkit-search-results-button),
:deep(input[type='search']::-webkit-search-results-decoration) {
  -webkit-appearance: none;
}
</style>
